// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M8 4H16V1H18V4H22V9H2V4H6V1H8V4Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 10.9999V22H2V10.9999H22ZM18.5 14.5H14.5V18.5H18.5V14.5Z"}}]};

const CalendarEventFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'calendar-event-filled',
    ref,
    icon: element,
  },
));

CalendarEventFilledIcon.displayName = 'CalendarEventFilledIcon';

export default CalendarEventFilledIcon;
